import adminEmployeeApi from '../../api/admin/employee'
import router from '../../router'
import {STATUS_MESSAGE} from '@/utils/notificationMessage'
import Vue from 'vue'

export const state = () => ({
  employees: [],
  detailEmployee: {

  },
  totalItems: 0,
  totalPages: 0,
  editEmployee: {
  },
  errorMessage: {

  },
  roles: [],
  listHistoryLogs: ''
})

export const getter = {}

export const mutations = {
  LIST_EMPLOYEE (state, slug) {
    state.employees = [...slug]
  },
  DETAIL_EMPLOYEE (state, slug) {
    state.detailEmployee = { ...slug }
    state.editEmployee = { ...slug }
  },
  CHANE_TOTAL (state, slug) {
    state.totalItems = slug.total_items
    state.totalPages = slug.total_pages
  },
  CHANGE_EMPLOYEE (state, slug) {
    Object.assign(state.editEmployee, { ...slug })
    if (state.employees.length > 0) {
      const tmpEmployees = [ ...state.employees ]
      const index = tmpEmployees.findIndex(u => u.id === slug.id)
      Object.assign(tmpEmployees[index], { ...slug })
      state.employees = tmpEmployees
    }
  },
  CHANGE_MESSAGE_ERROR (state, slug) {
    state.errorMessage = { ...slug }
  },
  CHANGE_ROLE (state, slug) {
    state.roles = { ...slug }
  },
  LIST_HISTORY_LOGS (state, slug) {
    state.listHistoryLogs = { ...slug }
  }
}

export const actions = {
  async getEmployee ({commit}, params) {
    try {
      const res = await adminEmployeeApi.getEmployee(params)
      if (res.status === 200) {
        commit('LIST_EMPLOYEE', res.data.data)
        commit('CHANE_TOTAL', res.data.metadata)
      }
    } catch (error) {

    }
  },
  async addEmployee ({commit}, params) {
    try {
      const res = await adminEmployeeApi.createEmployee(params.formData)
      if (res.status === 201) {
        params.clearParams()
        params.modal.hide()
        const resList = await adminEmployeeApi.getEmployee({page_index: 1, company_id: params.id})
        if (resList.status === 200) {
          commit('LIST_EMPLOYEE', resList.data.data)
          commit('CHANE_TOTAL', resList.data.metadata)
        }
      }
    } catch (error) {
      commit('CHANGE_MESSAGE_ERROR', error.response.data.error)
    }
  },
  async detailEmployee ({commit}, params) {
    try {
      const res = await adminEmployeeApi.getDetailEmployee(params)
      if (res.status === 200) {
        res.data.data.password = ''
        commit('DETAIL_EMPLOYEE', res.data.data)
      }
    } catch (error) {

    }
  },
  async updateEmployee ({commit}, params) {
    const vm = new Vue()
    try {
      const res = await adminEmployeeApi.updateEmployee(params)
      if (res.status === 201) {
        params.modal.hide()
        commit('CHANGE_EMPLOYEE', res.data.data)
        vm.$toastr.s(STATUS_MESSAGE.UPDATED)
      }
    } catch (error) {
      commit('CHANGE_MESSAGE_ERROR', error.response.data.error)
    }
  },
  async deleteEmployee ({commit}, params) {
    try {
      const res = await adminEmployeeApi.deleteEmployee(params)
      if (res.status === 204) {
        params.modal.hide()
        router.push('/admin/companies/' + params.company_id + '/employees')
        const resList = await adminEmployeeApi.getEmployee({page_index: 1, company_id: params.company_id})
        if (resList.status === 200) {
          commit('LIST_EMPLOYEE', resList.data.data)
          commit('CHANE_TOTAL', resList.data.metadata)
        }
      }
    } catch (error) {
    }
  },
  async getRole ({commit}, params) {
    try {
      const res = await adminEmployeeApi.getRole(params)
      if (res.status === 200) {
        commit('CHANGE_ROLE', res.data.data)
      }
    } catch (error) {

    }
  },
  async getListLogs ({commit}, params) {
    try {
      const res = await adminEmployeeApi.getListHistoryLogs(params)
      if (res.status === 200) {
        commit('LIST_HISTORY_LOGS', res.data.data)
      }
    } catch (error) {

    }
  },
  async setSettings ({commit}, params) {
    let vm = new Vue()
    try {
      await adminEmployeeApi.setSettings(params)
      vm.$toastr.s(STATUS_MESSAGE.UPDATED)
    } catch (error) {}
  }
}

export default {
  namespaced: true,
  state,
  getter,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/admin/employee.js